import i18n from '../../../../i18n';
import { UkgDateFormat } from '../../../Enums/UkgDateFormat';
import  DateFormatService from "../../../services/DateFormatService"

const displayDate = (target, workplan) => {
    let auxState = workplan.states.find(status => status.isCurrent);
    
    if (workplan.currentStatus.value === 3) {
        if (workplan.currentStatus[target] === '3000-01-01') {
            return i18n.t('workplanManager:workPlanView.global.forever');
        } else {
            return DateFormatService.formatDateOrEmpty(workplan.currentStatus[target], UkgDateFormat.LongDate);
        }

    }
    if (!auxState || !auxState[target]) {
        return '';
    }
    if (auxState[target] === '3000-01-01') {
        return i18n.t('workplanManager:workPlanView.global.forever');
    }
    return DateFormatService.formatDateOrEmpty(auxState[target], UkgDateFormat.LongDate)
};

export const formatWorkplans = (workplans) => workplans.map((fwp) => {
    return {
        displayEffectiveDate: displayDate('effectiveDate', fwp),
        displayEndDate: displayDate('endDate', fwp),
        ...fwp
    };
});